<template>
  <div
    class="dasha-table mr-auto mx-auto"
    :style="`
    width: 100%;
    background-color: #f9f9f9;
    font-size: ${font_size}px;
    direction: ltr;`"
  >

    <table class="table mb-3" style="background-color: white; border: 1px solid #ccc">
      <tr>
        <td style="text-align: center; padding: 5px">
          <strong>
            {{ convertDate(data["vimshottari"]["end"]) }}
          </strong>
        </td>
        <td
          style="
            text-align: center;
            padding: 5px;
            border-right: 7px solid rgba(0, 0, 0, 0.7);
          "
          v-if="!isMobile()"
        >
          پایان
        </td>
        <td style="text-align: center; padding: 5px">
          <strong>{{convertDate(checkStartofDasha(data["vimshottari"]["start"]))  }}</strong>
        </td>
        <td
          style="
            text-align: center;
            padding: 5px;
            border-right: 3px solid rgba(0, 0, 0, 0.7);
          "
          v-if="!isMobile()"
        >
          ابتدا
        </td>
      </tr>
    </table>



    <table
      class="table mb-2"
      v-for="item in dasha_data"
      :key="item['key']"
      @click="openSubDasha(item['periods'], dasha_data)"
      :style="`cursor: pointer ;
        background-color: white;
        border-right: 3px solid ${getDashaBg(item['start'], item['end'])};
        display: ${shouldShowDashaRange(item['start'], item['end'])};`"
    >



      <tr>
        <td style="text-align: center; border: 1px solid #ccc; padding: 5px">
          <strong>
            {{ convertDate(item["end"]) }}
          </strong>
        </td>
        <td style="text-align: center; border: 1px solid #ccc; padding: 5px">
          <strong>
            {{ convertDate(checkStartofDasha(item["start"])) }}
          </strong>
        </td>
        <td style="text-align: center; border: 1px solid #ccc; padding: 5px">
          <strong>
            {{ insertDashaFormat(item["key"])["name"] }}
          </strong>
        </td>
      </tr>





      <tr v-if="show_duration">
        <td colspan="3" style="text-align: center; border: 1px solid #ccc; padding: 5px">
          <div class="row p-0 m-0">
            <div
              class="col-12"
              style="
                text-align: right;
                direction: rtl;
                font-size: 12px;
                font-weight: bold;
              "
            >
              {{ getDuration(item["duration"]) }}
              <span
                v-if="getRemains(item['start'], item['end'])"
                v-html="getRemains(item['start'], item['end'])"
              >
              </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div class="row m-2 p-2 text-center" v-if="dasha_view_lvl > 0">
      <div class="col p-2" style="text-align: left">
        <div style="text-align: left; color: black; font-size: 12px">
          <strong style="line-height: 2em; cursor: pointer" @click="openParentDasha()">{{
            parentKeyName
          }}</strong>
        </div>
      </div>
      <div
        class="col-auto p-2"
        style="
          text-align: center;
          background-color: #fff;
          color: black;
          font-size: 12px;
          border-radius: 5px;
          border: 1px solid #ccc;
          cursor: pointer;
        "
        @click="openParentDasha()"
      >
        <strong>قبلی</strong>
        &nbsp;
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-return-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"
          />
        </svg>
      </div>
    </div>

    <div class="d-flex flex-row gap-2">

    <div style="width: 100%; padding: 5px; text-align: center">
      <span @click="changeDurationVisible()" style="font-size: 12px; cursor: pointer">
        نمایش مدت زمان دوره‌ها
      </span>
      <span
        ><input
          type="checkbox"
          name="show_duration"
          @change="changeDurationVisible()"
          :checked="show_duration"
      /></span>
    </div>


    <div style="width: 100%; padding: 5px; text-align: center">
      <span @click="changeDate()" style="font-size: 12px; cursor: pointer">
        نوع تاریخ
      </span>
      <span
      ><input
        type="checkbox"
        name="change_date"
        @change="changeDate()"
        :checked="change_date"
      /></span>
    </div>



    </div>





  </div>
</template>

<script>
import HelperLib from "./helper";
import moment from "jalali-moment";

export default {
  name: "DashaTable",
  components: {
    HelperLib,
  },
  props: {
    data: {
      type: Object,
    },
    date_type: {
      type: String,
      default: "jalali",
    },
    box_width: {
      type: Number,
    },
    birthdate: "",
  },
  data() {
    return {
      show_duration: false,
      change_date : false,
      font_size: "14",
      dasha_data: [],
      parent_dasha: [],
      dasha_view_lvl: 0,
      parentKeyName: "",
      serial_keys: [],
      is_active: false,
      current_dasha_color: "white",
    };
  },
  mounted() {
    this.adjustViewData();
    if (HelperLib.isMobile()) {
      this.font_size = "12";
    }
  },
  watch: {
    data: function (data) {
      this.resetDashaTable();
      // this.dasha_data = data
      this.dasha_data = data["vimshottari"]["periods"];
    },
    date_type: function (data) {
      this.date_type = data;
    },
  },
  methods: {
    changeDurationVisible() {
      if (this.show_duration) {
        this.show_duration = false;
      } else {
        this.show_duration = true;
      }
    },


    convertDate(date) {
      if (this.change_date) {
        let format, outputFormat;
        if (this.date_type === 'jalali') {
          format = date.includes(':') ? 'jYYYY-jMM-jDD HH:mm' : 'jYYYY-jMM-jDD';
          outputFormat = date.includes(':') ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
          return moment(date, format, 'fa').format(outputFormat);
        } else {
          format = date.includes(':') ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
          outputFormat = date.includes(':') ? 'jYYYY-jMM-jDD HH:mm' : 'jYYYY-jMM-jDD';
          return moment(date, format).format(outputFormat);
        }
      }
      return date;
    },



    changeDate() {
      if (this.change_date) {
        this.change_date = false;
      } else {
        this.change_date = true;
      }
    },


    getDuration(dur) {
      return this.durationFormat(dur);
    },
    getRemains(start, end) {
      if (this.date_type == "jalali") {
        var s_mo = moment.from(start, "fa", "jYYYY-jMM-jDD");
        var e_mo = moment.from(end, "fa", "jYYYY-jMM-jDD");
        var now = moment();
        now = now.locale("fa");
        if (now.isBetween(s_mo, e_mo)) {
          let count_down = e_mo.diff(now, "days");
          count_down = this.durationFormat(count_down, true) + " مانده";
          let out = "، از این دوره " + count_down + " است. ";
          return out;
        } else {
          return "";
        }
      }
      if (this.date_type == "gregorian") {
        var s_mo = moment.from(start, "en", "YYYY-MM-DD");
        var e_mo = moment.from(end, "en", "YYYY-MM-DD");
        var now = moment();
        now = now.locale("en");
        if (now.isBetween(s_mo, e_mo)) {
          let count_down = e_mo.diff(now, "days");
          count_down = this.durationFormat(count_down, true) + " مانده";
          let out = "، از این دوره " + count_down + " است. ";
          return out;
        } else {
          return "";
        }
      }
    },
    durationFormat(n_of_days, with_days = false) {
      return HelperLib.durationFormat(n_of_days, with_days);
    },
    checkStartofDasha(start) {
      if (this.date_type == "jalali") {
        var s_mo = moment.from(start, "fa", "jYYYY-jMM-jDD");
        let b_start = moment.from(this.birthdate, "en", "YYYY-MM-DD HH:mm");
        if (s_mo.isBefore(b_start)) {
          start = b_start.format("jYYYY-jMM-jDD HH:mm");
        }
        return start;
      }
      if (this.date_type == "gregorian") {
        var s_mo = moment.from(start, "en", "YYYY-MM-DD");
        let b_start = moment.from(this.birthdate, "en", "YYYY-MM-DD HH:mm");
        if (s_mo.isBefore(b_start)) {
          start = b_start.format("YYYY-MM-DD HH:mm");
        }
        return start;
      }
    },
    getDashaBg(start, end) {
      if (this.date_type == "jalali") {
        var s_mo = moment.from(start, "fa", "jYYYY-jMM-jDD");
        var e_mo = moment.from(end, "fa", "jYYYY-jMM-jDD");
        var now = moment();
        now = now.locale("fa");
        if (now.isBetween(s_mo, e_mo)) {
          return "rgba(51, 153, 102, 1)";
        } else {
          return "rgba(0,0,0, 0.8)";
        }
      }
      if (this.date_type == "gregorian") {
        var s_mo = moment.from(start, "en", "YYYY-MM-DD");
        var e_mo = moment.from(end, "en", "YYYY-MM-DD");
        var now = moment();
        now = now.locale("en");
        if (now.isBetween(s_mo, e_mo)) {
          return "rgba(51, 153, 102, 1)";
        } else {
          return "rgba(0,0,0, 0.8)";
        }
      }
    },
    shouldShowDashaRange(start, end) {
      if (this.date_type == "jalali") {
        var e_mo = moment.from(end, "fa", "jYYYY-jMM-jDD");
        let b_start = moment.from(this.birthdate, "en", "YYYY-MM-DD HH:mm");
        if (e_mo.isBefore(b_start)) {
          return "none";
        } else {
          return "table";
        }
      }
      if (this.date_type == "gregorian") {
        var e_mo = moment.from(end, "en", "YYYY-MM-DD");
        let b_start = moment.from(this.birthdate, "en", "YYYY-MM-DD HH:mm");
        if (e_mo.isBefore(b_start)) {
          return "none";
        } else {
          return "table";
        }
      }
    },
    resetDashaTable() {
      this.dasha_data = [];
      this.parent_dasha = [];
      this.dasha_view_lvl = 0;
      this.parentKeyName = "";
      this.serial_keys = [];
      this.is_active = false;
    },
    isMobile() {
      return HelperLib.isMobile();
    },
    adjustViewData() {
      this.dasha_data = this.data["vimshottari"]["periods"];
    },
    openSubDasha(periods, parent, parent_key) {
      if (periods) {
        ++this.dasha_view_lvl;
        this.parent_dasha.push(parent);
        this.dasha_data = periods;
      }
      // console.log(this.dasha_view_lvl, periods, parent)
    },
    checkCurrentDasha(start, end) {
      // console.log('test');
      // console.log(start, end)
    },
    insertDashaFormat(val) {
      var input = val.match(/(.{1,2})/g);

      var out = "";
      if (this.dasha_view_lvl <= 1) {
        this.parentKeyName = this.formatGrahaName(input[0]);
      }
      if (this.dasha_view_lvl >= 2) {
        this.parentKeyName =
          this.formatGrahaName(input[0]) + "/" + this.formatGrahaName(input[1]);
      }
      for (var i = 0; i < input.length; i++) {
        if (i != input.length - 1) {
          out += this.formatGrahaName(input[i]) + "/";
        } else {
          out += this.formatGrahaName(input[i]);
        }
      }
      return {
        name: out,
      };
    },
    formatGrahaName(sans) {
      var grahas = {
        Sy: "Su",
        Ch: "Mo",
        Ma: "Ma",
        Bu: "Me",
        Gu: "Ju",
        Sk: "Ve",
        Sa: "Sa",
        Ra: "Ra",
        Ke: "Ke",
      };
      for (var [key, value] of Object.entries(grahas)) {
        if (key == sans) {
          return value;
        }
      }
    },
    openParentDasha() {
      // console.log(this.dasha_view_lvl, this.parent_dasha, this.dasha_data)
      if (this.dasha_view_lvl == 1) {
        this.dasha_data = this.data["vimshottari"]["periods"];
        this.dasha_view_lvl = 0;
      } else {
        this.dasha_data = this.parent_dasha[this.dasha_view_lvl - 1];
        this.dasha_view_lvl = this.dasha_view_lvl - 1;
      }
      this.parent_dasha.pop();
    },
  },
};
</script>
